import { render, staticRenderFns } from "./NoteItem.vue?vue&type=template&id=221c9f1b&scoped=true"
import script from "./NoteItem.vue?vue&type=script&lang=js"
export * from "./NoteItem.vue?vue&type=script&lang=js"
import style0 from "./NoteItem.vue?vue&type=style&index=0&id=221c9f1b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "221c9f1b",
  null
  
)

export default component.exports